import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-result-type-percent",
  "use": "icon-result-type-percent-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-result-type-percent\">\n<path d=\"M7 17L17 7\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<circle cx=\"8\" cy=\"8\" r=\"2\" fill=\"currentColor\" />\n<circle cx=\"16\" cy=\"16\" r=\"2\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol